// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"BP-z","categoryName":"CP-z","categoryNameSearchHeader":"DP-z","categoryContent":"EP-z","bottomAligned":"FP-z","image":"GP-z","imageNoBackground":"HP-z"};